import React, {Suspense, useState} from 'react';
import {connect} from 'react-redux';
import {Amplify} from 'aws-amplify';
import Sidebar from './Component/Common/Sidebar';
import {useNavigate} from 'react-router-dom';
import menu from '../src/Component/Data/Menu/Menu.json';
import awsconfig from './aws-exports';
import {AuthProvider} from './Contexts/AuthContext';
import {ToastProvider} from './Contexts/ToastContext';

Amplify.configure(awsconfig);

const MainIndex = React.lazy(() => import('./Screen/MainIndex'));
const AuthIndex = React.lazy(() => import('./Screen/AuthIndex'));

const RouteFallback = () => (
    <div className="d-flex align-items-center justify-content-center vh-100">
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);

function App(props) {
    const [menuData, setMenuData] = useState([...menu.menu]);
    const navigate = useNavigate();
    const savedThemeColor = localStorage.getItem("themeColor");
    const themeColor = !(savedThemeColor === null) ? savedThemeColor : "cyan";
    const savedIsSidebarMini = localStorage.getItem("isSideBarMini");
    const initIsSidebarMini = !(savedIsSidebarMini === null) ? savedIsSidebarMini === "true" : false;

    var baseUrl = process.env.PUBLIC_URL
    const activekey = () => {
        var res = window.location.pathname
        var baseUrl = process.env.PUBLIC_URL
        baseUrl = baseUrl.split("/");
        res = res.split("/");
        res = res.length > 0 ? res[baseUrl.length] : "/";
        res = res ? "/" + res : "/";
        ;
        const activeKey1 = res;
        if (activeKey1 === '/') {
            return '/home'
        } else {
            return activeKey1
        }
    }
    if (activekey() === '/home' || activekey() === '/404page') {
        return (
            <div id="cryptoon-layout" className={'theme-' + themeColor}>
                <ToastProvider>
                    <AuthProvider>
                        <Suspense fallback={<RouteFallback/>}>
                            <AuthIndex/>
                        </Suspense>
                    </AuthProvider>
                </ToastProvider>
            </div>
        );
    }
    const GotoChangeMenu = (val) => {
        // props.history.push("dashboard");
        navigate(baseUrl + '/')
        setMenuData([...menu.menu]);
    }

    // console.log(activekey())
    return (

        <div id='cryptoon-layout' className={'theme-' + themeColor}>
            <ToastProvider>
                <AuthProvider>
                    <Sidebar
                        activekey={activekey()}
                        menuData={menuData}
                        GotoChangeMenu={(val) => {
                            GotoChangeMenu(val)
                        }}
                        initIsSidebarMini={initIsSidebarMini}
                    />
                    <Suspense fallback={<RouteFallback/>}>
                        <MainIndex activekey={activekey()}
                                   GotoChangeMenu={(val) => {
                                       GotoChangeMenu(val)
                                   }}
                        />
                    </Suspense>
                </AuthProvider>
            </ToastProvider>
        </div>
    );
}

const mapStateToProps = ({Mainreducer}) => ({
    Mainreducer
})

export default connect(mapStateToProps, {})(App);
